import { render, staticRenderFns } from "./SongDetai.vue?vue&type=template&id=887ec67e&"
import script from "./SongDetai.vue?vue&type=script&lang=js&"
export * from "./SongDetai.vue?vue&type=script&lang=js&"
import style0 from "./SongDetai.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports